import { Stack, SxProps, Typography, useTheme } from '@mui/material';

import { FC } from 'react';
import { pxToRem } from '@/theme/typography';

interface TransactionRowInfoProps {
  title: string;
  description: string;
}

export const TransactionRowInfo: FC<TransactionRowInfoProps> = ({
  title,
  description,
}) => {
  const theme = useTheme();

  const titleSx: SxProps = {
    fontSize: pxToRem(14),
    fontWeight: '400',
    color: theme.palette.grey[40],
  };

  const descriptionSx: SxProps = {
    ...titleSx,
    color: theme.palette.grey[70],
  };

  return (
    <Stack
      direction='row'
      sx={{
        marginTop: '4px',
        alignItems: 'center',
      }}
    >
      <Typography component='span' sx={titleSx}>
        {title}
      </Typography>
      &nbsp;
      <Typography component='span' sx={descriptionSx}>
        {description}
      </Typography>
    </Stack>
  );
};
